// src/types/workspace-developer/WorkspaceDeveloperRequests.ts
var WorkspaceDeveloperRequestStatusClass = /* @__PURE__ */ ((WorkspaceDeveloperRequestStatusClass2) => {
  WorkspaceDeveloperRequestStatusClass2["Success"] = "2xx";
  WorkspaceDeveloperRequestStatusClass2["Redirect"] = "3xx";
  WorkspaceDeveloperRequestStatusClass2["ClientError"] = "4xx";
  WorkspaceDeveloperRequestStatusClass2["ServerError"] = "5xx";
  return WorkspaceDeveloperRequestStatusClass2;
})(WorkspaceDeveloperRequestStatusClass || {});
var WorkspaceDeveloperRequestBodyState = /* @__PURE__ */ ((WorkspaceDeveloperRequestBodyState2) => {
  WorkspaceDeveloperRequestBodyState2["Stored"] = "stored";
  WorkspaceDeveloperRequestBodyState2["None"] = "none";
  WorkspaceDeveloperRequestBodyState2["NotStoredByPolicy"] = "not_stored_by_policy";
  WorkspaceDeveloperRequestBodyState2["OverCap"] = "over_cap";
  return WorkspaceDeveloperRequestBodyState2;
})(WorkspaceDeveloperRequestBodyState || {});

export {
  WorkspaceDeveloperRequestStatusClass,
  WorkspaceDeveloperRequestBodyState
};
